import { toast } from 'sonner';
import { resolveError } from '@/core/errors/resolveError';
import { AppErrorCode } from '@/core/errors/appErrorCode';

const GENERIC_CODES: AppErrorCode[] = [
  AppErrorCode.UNKNOWN,
  AppErrorCode.INTERNAL_ERROR,
  AppErrorCode.UNAUTHORIZED,
  AppErrorCode.FORBIDDEN,
  AppErrorCode.NOT_FOUND,
];

/** Maps errors to Sonner toast (Portuguese copy via resolveError); the fallback only covers generic errors. */
export function useErrorToast() {
  return (err: unknown, fallback?: string) => {
    const { code, message } = resolveError(err);
    toast.error(GENERIC_CODES.includes(code) ? (fallback ?? message) : message);
  };
}
